import React, { useState } from "react";
import "./white_discharge_template_date.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
export default function Whitedischarge(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);
  let bmiValue =
    formData?.height && formData?.weight
      ? ((formData.weight / formData.height ** 2) * 10000).toFixed(2)
      : "";

  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });
  const [pastHRows, setPastHRows] = useState([
    {
      condition: "",
      duration: "",
      medication: "",
    },
  ]);

  const pastHRowAdd = () => {
    setPastHRows([
      ...pastHRows,
      {
        condition: "",
        duration: "",
        medication: "",
      },
    ]);
  };
  const pastHRowRemove = (i) => {
    let newInvest = pastHRows.filter((row, ind) => i !== ind);
    setPastHRows(newInvest);
  };

  const pastHValue = (ind, e) => {
    const { name, value } = e.target;
    const newRows = [...pastHRows];
    newRows[ind][name] = value;
    setPastHRows(newRows);
  };

  const [drugOneRows, setDrugOneRows] = useState([
    {
      drug: "",
      dosage: "",
      frequency: "",
      relationship: "",
      duration: "",
    },
  ]);

  const drugOneRowAdd = () => {
    setDrugOneRows([
      ...drugOneRows,
      {
        drug: "",
        dosage: "",
        frequency: "",
        relationship: "",
        duration: "",
      },
    ]);
  };
  const drugOneRowRemove = (i) => {
    let newInvest = drugOneRows.filter((row, ind) => i !== ind);
    setDrugOneRows(newInvest);
  };

  const drugOneValues = (ind, e) => {
    const { name, value } = e.target;
    const newRows = [...drugOneRows];
    newRows[ind][name] = value;
    setDrugOneRows(newRows);
  };

  const [drugTwoRows, setDrugTwoRows] = useState([
    {
      drug: "",
      dosage: "",
      frequency: "",
      relationship: "",
      duration: "",
    },
  ]);

  const drugTwoRowAdd = () => {
    setDrugTwoRows([
      ...drugTwoRows,
      {
        drug: "",
        dosage: "",
        frequency: "",
        relationship: "",
        duration: "",
      },
    ]);
  };
  const drugTwoRowRemove = (i) => {
    let newInvest = drugTwoRows.filter((row, ind) => i !== ind);
    setDrugTwoRows(newInvest);
  };

  const drugTwoValues = (ind, e) => {
    const { name, value } = e.target;
    const newRows = [...drugTwoRows];
    newRows[ind][name] = value;
    setDrugTwoRows(newRows);
  };

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };

  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;
          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "White Discharge Template Date",
            },
          };

          // Dispatch action to create patient report
          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");

          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        props.loaderchange("false");

        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: "30px",
        // lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        height: "20px",
      }}
    >
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: "hidden",
        fontSize: "30px",
        lineHeight: "20px",
      }}
    >
      ●
    </span>
  );
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };

  return (
    <div id="Whitedischarge">
      <div className="Whitedischarge">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap:"3px"

            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formData.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formData.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formData.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option disabled selected>
                    Select
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.age1}
              </span>
            </div> */}

          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formData.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodGroup1}
              </span>
            </div> */}
          {/* </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <p>
            White discharge Template{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="template"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.template}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date{" "}
            <input
              type="date"
              className={`createTime ${show ? "hide" : "show"}`}
              name="date"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.date}
            </span>
          </p>
          {/* <p>
          Name:{" "}
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            name="name"
            onChange={handleChange}
          />
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{formData.name}
          </span>
          Age:{" "}
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            name="age"
            onChange={handleChange}
          />
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{formData.age}
          </span>
        </p>
        <p>
          UHID (Should come automatically){" "}
          <input
            className={`createTime ${show ? "hide" : "show"}`}
            name="uhid"
            onChange={handleChange}
          />
          <span className={`input ${!show ? "hide" : "show"}`}>
            &nbsp;{formData.uhid}
          </span>
        </p> */}
          {/* <p>
            Occupation{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="occupation"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.occupation}
            </span>
          </p> */}
          <p>
            C/O discharge PV
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              name="codischargepv"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.codischargepv}
            </span>
            days / months
          </p>
          <p>
            C/O itching PV{" "}
            <select
              name="itchingPV"
              onChange={handleChange}
              style={{ border: "1px solid gray", borderRadius: "3px" }}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option selected disabled>
                select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.itchingPV}
            </span>
          </p>
          <p>
            C/o Urinary symptoms{" "}
            <select
              name="urinarySymptoms"
              onChange={handleChange}
              style={{ border: "1px solid gray", borderRadius: "3px" }}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option selected disabled>
                select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.urinarySymptoms}
            </span>
          </p>
          <p>
            c/o painful intercourse{" "}
            <select
              name="painfulIntercourse"
              style={{ border: "1px solid gray", borderRadius: "3px" }}
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option selected disabled>
                select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.painfulIntercourse}
            </span>
          </p>
          <br />
          <br />
          <p>Menstrual H/o</p>
          <p>
            LMP:{" "}
            <input
              type="date"
              className={`createTime ${show ? "hide" : "show"}`}
              name="lmp"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.lmp}
            </span>
            Cycles:{" "}
            <select
              name="cycles"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Regular">Regular</option>
              <option value="Irregular">Irregular</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.cycles}
            </span>
          </p>
          <p>
            Frequency:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="frequency"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.frequency}
            </span>
          </p>
          <p>
            Pain during periods:{" "}
            <select
              name="painPeriods"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.painPeriods}
            </span>
          </p>
          <br />
          <br />
          <p>
            Obstetric h/o P L (1-10) numbers{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="obstetricH"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.obstetricH}
            </span>
          </p>
          <p>Prev --- Vaginal delivery</p>
          <p>Prev --- Cesarean</p>
          <p>
            Sterilization{" "}
            <select
              name="sterilization"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.sterilization}
            </span>
          </p>
          <br />
          <br />
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <caption className="caption">
            Past H/o
            <br />
          </caption>
          <tbody>
            <tr>
              <th>Condition</th>
              <th>Duration</th>
              <th>Medications</th>
              <th>Actions</th>
            </tr>
            {pastHRows.map((ele, i) => (
              <tr>
                <td>
                  <select name={`condition`} onChange={(e) => pastHValue(i, e)}>
                    <option disabled selected>
                      Select
                    </option>
                    <option value="Diabetes" key="">
                      Diabetes
                    </option>
                    <option value="Hypertension" key="">
                      Hypertension
                    </option>
                    <option value="TB" key="">
                      TB
                    </option>
                    <option value="Hypothyroid" key="">
                      Hypothyroid
                    </option>
                    <option value="Hyperthyroid" key="">
                      Hyperthyroid
                    </option>
                    <option value="Nil" key="">
                      Nil
                    </option>
                  </select>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`duration`}
                    onChange={(e) => pastHValue(i, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formData.duration}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`medication`}
                    onChange={(e) => pastHValue(i, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formData.medication1}
                  </span>
                </td>

                <td style={{ textAlign: "center" }}>
                  {i == 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={(e) => pastHRowAdd(i)}
                    >
                      +
                    </button>
                  )}
                  {i > 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={() => pastHRowRemove(i)}
                    >
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        <br />
        <div className="detail">
          <p>
            On examination:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="onExamination"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.onExamination}
            </span>
          </p>
          <p>
            GC Fair; Hydration-Adequate;{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="hydration"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.hydration}
            </span>
          </p>
          <p>
            BP{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="bp"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.bp}
            </span>
            mm/hg; PR{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pr"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.pr}
            </span>
          </p>
          <p>
            Height:
            <input
              name="height"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={handleChange}
            />{" "}
            m
          </p>
          <p>
            Weight:{" "}
            <input
              name="weight"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={handleChange}
            />{" "}
            KGs
          </p>
          <p>
            BMI:
            <input
              type="text"
              name="bmi"
              className={`createTime ${show ? "hide" : "show"}`}
              value={bmiValue}
            />
            KG/m<sup style={{ fontWeight: "bold" }}>2</sup>
          </p>
          <p>
            Per abdomen:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="perAbdomen"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.perAbdomen}
            </span>
          </p>
          <p>
            PS{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="ps"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.ps}
            </span>
          </p>
          <p>
            PV{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pv"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.pv}
            </span>
          </p>
          <p>
            Pap smear/ HPV{" "}
            <select
              name="papSmear"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.papSmear}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lab:{" "}
            <select
              name="lab"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Third eye">Third eye</option>
              <option value="Karkinos">Karkinos</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.lab}
            </span>
          </p>
          <p>
            Vaginal Swab{" "}
            <select
              name="vaginalSwab"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.vaginalSwab}
            </span>
          </p>
          <p>
            Cervical cancer vaccine Adviced{" "}
            <select
              name="cervicalVaccine"
              onChange={handleChange}
              className={`createTime ${show ? "hide" : "show"}`}
            >
              <option disabled selected>
                Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.cervicalVaccine}
            </span>
          </p>
          <br />
          <br />
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>Drug </th>
              <th>Dosage NUMBERS</th>
              <th>Frequency</th>
              <th>Relationship with food</th>
              <th>Duration</th>
              <th>Actions</th>
            </tr>
            {drugOneRows.map((ele, i) => {
              return (
                <tr>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="drug"
                      onChange={(e) => drugOneValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugName1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="dosage"
                      onChange={(e) => drugOneValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugDosage1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="frequency"
                      onChange={(e) => drugOneValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugFrequency1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="relationship"
                      onChange={(e) => drugOneValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugFoodRelationship1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="duration"
                      onChange={(e) => drugOneValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugDuration1}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {i == 0 && (
                      <button
                        className={`${show ? "hide" : "show"}`}
                        onClick={(e) => drugOneRowAdd(i)}
                      >
                        +
                      </button>
                    )}
                    {i > 0 && (
                      <button
                        className={`${show ? "hide" : "show"}`}
                        onClick={() => drugOneRowRemove(i)}
                      >
                        -
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
        <br />
        <div className="detail">
          <p>HUSBAND</p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              
              <th>Drug </th>
              <th>Dosage NUMBERS</th>
              <th>Frequency</th>
              <th>Relationship with food</th>
              <th>Duration</th>
              <th>Actions</th>
            </tr>
            {drugTwoRows.map((ele, i) => {
              return (
                <tr>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="drug"
                      onChange={(e) => drugTwoValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugName1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="dosage"
                      onChange={(e) => drugTwoValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugDosage1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="frequency"
                      onChange={(e) => drugTwoValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugFrequency1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="relationship"
                      onChange={(e) => drugTwoValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugFoodRelationship1}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      name="duration"
                      onChange={(e) => drugTwoValues(i, e)}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData.drugDuration1}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {i == 0 && (
                      <button
                        className={`${show ? "hide" : "show"}`}
                        onClick={(e) => drugTwoRowAdd(i)}
                      >
                        +
                      </button>
                    )}
                    {i > 0 && (
                      <button
                        className={`${show ? "hide" : "show"}`}
                        onClick={() => drugTwoRowRemove(i)}
                      >
                        -
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
        <br />
        <div className="bulletin">
          <h1>TIPS</h1>
          <p>
            There is no need to prevent normal vaginal discharge. However,
            abnormal vaginal discharge may be prevented by following these tips.
          </p>
          <ul>
            <li>After using the toilet, always wipe from front to back</li>
            <li>Wash down below before and after sex</li>
            <li>
              Wear cotton panties during the day to allow your genital area to
              “breathe.” Don’t wear panties at night.
            </li>
            <li>Avoid wearing leggings, jeans for long periods</li>
            <li>The latex in condoms can be irritating for some women</li>
            <li>
              Avoid using razors or other products that may cause itching, such
              as tampons or bubble baths
            </li>
            <li>
              When your vagina itches or you have unusual discharge, it’s
              important to find out why.
            </li>
          </ul>
        </div>
      </div>
      <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
      <div className={`Footer ${show ? "hide" : "show"}`}>
        <button onClick={handlesubmit} className="Button_Create">
          Add Report
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "block", marginBottom: "10px" }}>
            <h4
              style={{
                fontWeight: 600,
                marginRight: "5px",
                textAlign: "center",
              }}
            >
              White Discharge Template
            </h4>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Date :", formData.date)}
            {renderReportfield("C/O discharge PV :", formData.codischargepv)}
            {renderReportfield("C/O itching PV  :", formData.itchingPV)}
            {renderReportfield(
              "C/O Urinary symptoms  :",
              formData.urinarySymptoms
            )}
            {renderReportfield(
              "C/O painful intercourse  :",
              formData.painfulIntercourse
            )}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {/* {renderDiscPoint()} */}
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
              Menstrual H/o
            </h5>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("LMP :", formData.lmp)}
            {renderReportfield("Cycles :", formData.cycles)}
            {renderReportfield("Frequency :", formData.frequency)}
            {renderReportfield("Pain during periods :", formData.painPeriods)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield(
              "Obstetric h/o P L (1-10) numbers :",
              formData.obstetricH
            )}
            {renderReportfield("Prev --- Vaginal delivery")}
            {renderReportfield("Prev --- Cesarean")}
            {renderReportfield("Sterilization")}
          </div>

          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  {["S.No", "CONDITION", "DURATION", "MEDICATION"].map((ele) =>
                    renderTableTH(ele)
                  )}
                </tr>
              </thead>
              <tbody>
                {pastHRows.map((drug, i) => (
                  <tr key={i}>
                    {renderTableTD(i + 1)}
                    {renderTableTD(drug.condition)}
                    {renderTableTD(drug.duration)}
                    {renderTableTD(drug.medication)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("On examination :", formData.onExamination)}
            {renderReportfield(
              "GC Fair; Hydration-Adequate :",
              formData.hydration
            )}
            {renderReportfield("BP :", formData.bp)}mm/hg;
            {renderReportfield("PR :", formData.pr)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Height :", formData.height)}m
            {renderReportfield("Weight :", formData.weight)}KGs
            {renderReportfield("BMI :", formData.pr)}KG/m2
            {renderReportfield("Per abdomen :", formData.perAbdomen)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("PS :", formData.ps)}
            {renderReportfield("PV :", formData.pv)}
            {renderReportfield("Pap smear/ HPV :", formData.papSmear)}KG/m2
            {renderReportfield("Per abdomen :", formData.perAbdomen)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Lab :", formData.lab)}
            {renderReportfield("Vaginal Swab :", formData.vaginalSwab)}
            {renderReportfield(
              "Cervical cancer vaccine Adviced :",
              formData.cervicalVaccine
            )}
            KG/m2
          </div>
          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  {[
                    "SI No.",
                    "Drug",
                    "Dosage",
                    "Frequency",
                    "Relationship with food",
                    "Duration",
                  ].map((ele, i) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {drugOneRows.map((ele, ind) => (
                  <tr key={ind}>
                    {renderTableTD(ind + 1)}
                    {renderTableTD(ele.drug)}
                    {renderTableTD(ele.dosage)}
                    {renderTableTD(ele.frequency)}
                    {renderTableTD(ele.relationship)}
                    {renderTableTD(ele.duration)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {/* {renderDiscPoint()} */}
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>HUSBAND</h5>
          </div>
          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  {[
                    "SI No.",
                    "Drug",
                    "Dosage",
                    "Frequency",
                    "Relationship with food",
                    "Duration",
                  ].map((ele, i) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {drugTwoRows.map((ele, ind) => (
                  <tr key={ind}>
                    {renderTableTD(ind + 1)}
                    {renderTableTD(ele.drug)}
                    {renderTableTD(ele.dosage)}
                    {renderTableTD(ele.frequency)}
                    {renderTableTD(ele.relationship)}
                    {renderTableTD(ele.duration)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display: "block", marginBottom: "10px" }}>
            <h4
              style={{
                fontWeight: 600,
                marginRight: "5px",
                textAlign: "center",
              }}
            >
              TIPS
            </h4>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("There is no need to prevent normal vaginal discharge. However, abnormal vaginal discharge may be prevented by following these tips.","",{styleSec:{width:"100%"}})}
          </div>
          {[
            "After using the toilet, always wipe from front to back",
           " Wash down below before and after sex",
            "Wear cotton panties during the day to allow your genital area to “breathe.” Don’t wear panties at night.",
            "Avoid wearing leggings, jeans for long periods",
            "The latex in condoms can be irritating for some women",
            "Avoid using razors or other products that may cause itching, such as tampons or bubble baths",
            "When your vagina itches or you have unusual discharge, it’s important to find out why."
          ].map((ele, ind) => {
            return (
              <div style={{ display: "flex", marginBottom: "10px" }}>
                {renderIndentation()}
                {renderDiscPoint()}
                {renderReportfield(ele, "", { styleSec: { width: "100%" } })}
              </div>
            );
          })}

<div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
